module.exports = __webpack_public_path__ + "static/media/img32.f592dcba.jpg";